import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import JobComponent from '../components/jobComponent';
import LanternImg from '../assets/PlaceHolder/night.jpg';
import thumb from "../assets/thumb/stefan-lehner-IYa5Dnj9qWE-unsplash.jpg";


function Jobs() {
  return (
    <>
      <Navbar />
      <Hero 
        cName="hero-mid" 
        heroImg={thumb} 
        title="Hiring"
        btnClass="hide"/>
      <div className="jobs-header">

        
      </div>
      <JobComponent />
      <Footer />
    </>
  );
}

export default Jobs;
